import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=47a9cdfe&scoped=true&"
import script from "./Invite.vue?vue&type=script&lang=js&"
export * from "./Invite.vue?vue&type=script&lang=js&"
import style0 from "./Invite.vue?vue&type=style&index=0&id=47a9cdfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a9cdfe",
  null
  
)

export default component.exports